<template>
  <div>
    <v-card elevation="10">
      <v-card-title>{{ booking.capturedAddress }}</v-card-title>
      <v-card-text>
        <v-stepper v-model="step" class="elevation-0" alt-labels>
           <v-stepper-header class="elevation-0">
            <template v-for="n in steps.length">
              <v-stepper-step
                  :key="`${n}-step`"
                  :complete="step > n"
                  :step="n"
              >
                {{ steps[n - 1] }}
              </v-stepper-step>
              <v-divider
                  v-if="n !== steps.length"
                  :key="n"
              ></v-divider>
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <DriverPickup
                  v-bind:booking="booking"
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <DriverSchedule
                  v-bind:booking="booking"
              />
            </v-stepper-content>
            <v-stepper-content step="3">
              <DriverDropped
                  v-if="booking.status.type === 'DELIVERY'"
                  v-bind:booking="booking"
              />
              <DriverDisposed
                  v-else-if="booking.status.type === 'COLLECTION' || booking.status.type === 'EXCHANGE'"
                  v-bind:booking="booking"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-row no-gutters v-if="this.booking.status.status != 'QUOTE'">
        <v-col align="end">
          <v-btn light depressed style="text-align: end;" class="primary--text" v-on:click="showMap()"> {{ mapTitle }} </v-btn>
        </v-col>
      </v-row>
      <GmapMap
          v-if="this.isMap"
          :center="{ lat:booking.lat, lng: booking.long }"
          :zoom="15"
          class="map"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            disableDefaultUI: true
          }"
          style="width: 100%; height: 200px"
      >
        <GmapMarker :position="{ lat:booking.lat, lng: booking.long }" />
      </GmapMap>
    </v-card>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
import DriverPickup from "@/components/drivers/dashboard/DriverPickup";
import DriverSchedule from "@/components/drivers/dashboard/DriverSchedule";
import DriverDropped from '@/components/drivers/dashboard/DriverDropped';
import DriverDisposed from '@/components/drivers/dashboard/DriverDisposed';

export default {
  name: 'DriverCard',
  computed: {
    google: gmapApi,
  },

  components: {
    DriverDisposed,
    DriverDropped,
    DriverPickup,
    DriverSchedule,
    GmapMarker
  },
  props: {
    booking: Object,
  },
  data() {
    return {
      step: 1,
      steps: [
        'Available',
        'Scheduled',
        'Dropped'
      ],
      loading: false,
      show: true,
      mapTitle: 'Show Map',
      isMap: false,
    }
  },
  methods: {
    showMap(){
      this.isMap = !this.isMap;
      if(this.isMap){
        this.mapTitle = 'Hide Map';
      }
      else{
        this.mapTitle = 'Show Map';
      }
    }
  },
  watch:{
    booking(booking){
      if (booking.status.type === 'EXCHANGE') {
        this.steps = ['Available', 'Scheduled', 'Exchanged'];
      } else if (booking.status.type === 'COLLECTION') {
        this.steps = ['Available', 'Scheduled', 'Collected'];
      }
      else if (booking.status.type === 'DELIVERY') {
        this.steps = ['Available', 'Scheduled', 'Dropped'];
      }
    }
  },
  async mounted() {
    switch (this.booking.status.status) {
      case 'SCHEDULED':
        this.step = 2;
        break;
      case 'DROPPED':
        this.step = 3;
        break;
      case 'DISPOSING':
        this.step = 3;
        break;
      default:
        this.step = 1;
        break;
    }
    
  }
};
</script>

<style lang="scss" scoped>

</style>